import { MapLatLng } from './map.latlng';
import { MapPolygon } from './map.polygon';

export class MapPolygonPoint {
    public id: number;            // Identificador secuencial
    public dataModel: any;        // Objeto asociado (modelo de negocio)
    public content: string;       // Contenido que aparece cuando se picha sobre el punto (vértice)
    public polygon?: MapPolygon;  // Poligono que lo contiene
    public point: MapLatLng;      // Posición del vértice
    public marker?: any;          // Marcador del vértice
    public moved = false;         // Indica que se ha movido el punto (edición)
    public intermediary = false;  // Indica si es un punto intermedio
    // Agregados
    public clickPoint?: MapLatLng; // Punto sobre el que se ha pinchado en el mapa

    constructor(id: number, content: string, point: MapLatLng, dataModel: any) {
        this.id = id;
        this.content = content;
        this.point = point;
        this.dataModel = dataModel;
    }

    setData(data: any) {
        this.dataModel = (data !== undefined ? data : null);
    }
}
